import { BaseTokenRequestHandler, TokenResponse, AppAuthError, TokenError } from '@openid/appauth';

export class CustomTokenResponse extends TokenResponse {
  constructor(response) {
    super(response);
    this.ownerType = response.owner_type;
  }

  toJson() {
    const json = super.toJson();
    return {
      ...json,
      owner_type: this.ownerType,
    };
  }
}

export class CustomTokenRequestHandler extends BaseTokenRequestHandler {
  async performTokenRequest(configuration, request) {
    const tokenResponse = this.requestor.xhr({
      url: configuration.tokenEndpoint,
      method: 'POST',
      dataType: 'json', // adding implicit dataType
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      data: this.utils.stringify(request.toStringMap()),
    });

    const response = await tokenResponse;

    if (this.isTokenResponse(response)) {
      return new CustomTokenResponse(response);
    } else {
      return Promise.reject(new AppAuthError(response.error, new TokenError(response)));
    }
  }
}
